import React from 'react';
import ArticleCard from './ArticleCard';

export default function ArticleList({ articles, loading, error, page, pageCount, onPageChange }) {
  if (error) {
    return (
      <div className="state-message state-message--error">
        Couldn't reach the newsroom. {error}
      </div>
    );
  }

  if (loading) {
    return <div className="state-message">Loading the wire…</div>;
  }

  if (!articles.length) {
    return <div className="state-message">No articles in this category yet.</div>;
  }

  return (
    <>
      <div className="article-list">
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>

      {pageCount > 1 && (
        <div className="pagination">
          <button
            type="button"
            className="pagination__btn"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            ← Newer
          </button>
          <span className="pagination__status">
            Page {page} of {pageCount}
          </span>
          <button
            type="button"
            className="pagination__btn"
            disabled={page >= pageCount}
            onClick={() => onPageChange(page + 1)}
          >
            Older →
          </button>
        </div>
      )}
    </>
  );
}
